import UserManagement from "../../../components/Setting/UserManagement";
import React, { useState, useEffect } from "react";
import { Image } from "antd";
import menu from "../../../assets/Images/menudots.svg";
import plus from "../../../assets/Images/plus.svg";
import noImage from "../../../assets/Images/roundimage.png";

import { Dropdown } from "antd";
import AddUser from "../../../components/Setting/AddUser";
import { Breadcrumb } from "antd";
import {
  DoubleRightOutlined,
  DeleteOutlined,
  EditOutlined,
  StopOutlined,
} from "@ant-design/icons";
import Sidebar from "../../../components/SideBar/sidebar";
import Navbar from "../../../components/Navbar/Navbar";
import { routes } from "../../../Routes";
import {
  blockStoreUser,
  getStoreUsers,
} from "../../../API  Functions/UserMangement";
import { useSelector } from "react-redux";
import Blockuserpopup from "../../../modals/Blockuserpopup";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { toast } from "react-toastify";
import {
  GetRetailerDetails,
  getSubstores,
} from "../../../API  Functions/ProfileFunctions";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
// Dropdown data array

//

const Setting = () => {
  const { t, i18n } = useTranslation();
  // const user_id = useSelector((state) => state.login?.user?.user_id);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const store_data = useSelector((state) => state.login?.user?.result);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  // This is for use in add user button to open a new component
  const [showComponent, setShowComponent] = useState(false);
  const [storeuser, setstoreuser] = useState(null);

  const [popup, setpopup] = useState(false);
  const [blockdata, setblockdata] = useState([]);
  const [status, setstatus] = useState(1);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [retailerData, setretailerData] = useState({});
const [allUsers, setAllUsers] = useState([]); // 🔹 backup for search

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );
  const [subStores, setSubStores] = useState([]);
  const masterStore = useSelector((state) => state.login.masterStore);

  // const [noOfUserLimit, setNoOfUserLimit] = useState(0);

  useEffect(() => {
    console.log("ALLL STORE", allStores);

    if (allStores || masterStore) {
      getSubStoresData();
    }
  }, [allStores]);

  const getSubStoresData = () => {
    getSubstores(masterStore?.store_id).then((res) => {
      console.log("USERRRRR---> Res", res);

      setSubStores(res?.response);
    });
  };

  const getStoreusers = () => {
    setLoading(true);
    getStoreUsers(user_id)
      .then((res) => {
        // console.log("USER REPONSE s",res);

        if (res?.result[0]?.status_code === 200) {
          const users = res.result[0]?.response;
          // const userLimit = res.result[0]?.no_of_user || 0;

          // console.log("USEERR RLIMIT ", userLimit);

          if (users) {
            setData(users);
                    setAllUsers(users);   // original list for search

            // setNoOfUserLimit(userLimit);
            setLoading(false);
          } else {
            console.error("No users found in the response.");
            setLoading(false);
          }
        } else {
          console.error("Response was not successful:", res);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching store users:", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchdetails();
    getStoreusers();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };
  const blockstoreuser = async (val, block) => {
    const response = await blockStoreUser(
      user_id,
      val?.retailer_user_id
      // store_id,
      // val?.user_id ?? 0,
      // val?.user_record_link_id ?? 0,
      // block
    );
    // console.log("SSSSSSSSSS response", response?.data?.result[0]?.status);
    if (response?.data?.result[0]?.status === "Retailer User Deactivated") {
      setstatus(block);
      setblockdata(val);
      setpopup(true);
      getStoreusers();
    } else if (
      response?.data?.result[0]?.status ===
      "Please close the POS session for this user"
    ) {
      toast.error("Please close the POS session for this user");
    }
  };


  const searchUser = (searchText) => {
  if (!searchText || searchText.trim() === "") {
    setData(allUsers); // reset when empty
    return;
  }

  const text = searchText.toLowerCase();

const filteredUsers = allUsers.filter((user) => {
  const name = typeof user?.name === "string" ? user.name.toLowerCase() : "";
  const email =
    typeof user?.email === "string" ? user.email.toLowerCase() : "";
  const phone =
    typeof user?.phone === "string" ? user.phone.toLowerCase() : "";

  return (
    name.includes(text) ||
    email.includes(text) ||
    phone.includes(text)
  );
});


  setData(filteredUsers);
};


  return (
    <>
      {loading && <LoadingSpinner />}
      {/* <div className="flex"> */}
      {/* <div className="flex flex-col bg-[#F6F7F9] min-h-[93vh]  flex-1"> */}
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="user_management" />
        <div className="overflow-y-auto custom-scrollbar">
          <div className="me-4 ms-3 font-extrabold">
            {/* <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: t("settings"),
                  key: "settings",
                  children: (
                    <Link to={routes.settings.userManagement}>
                      {t("settings")}
                    </Link>
                  ),
                },
                { title: t("user_management") },
              ]}
              className="relative mt-3"
            /> */}
            {retailerData?.status == "approved" ? (
              <>
                {showComponent ? (
                  <AddUser
                    onClose={() => {
                      setShowComponent(false);
                      setstoreuser(null);
                      getStoreusers();
                    }}
                    isEdit={storeuser}
                    subStores={subStores}
                  />
                ) : (
                  <>
                    {/* <div className="bg-[#FFFFFF] shadow-sm rounded-xl grid mt-4 h-32">
                    <UserManagement />
                  </div> */}
                    <div className="flex flex-row items-end justify-between">
                      {/* {data?.length > 0 && (
                        <div className="font-semibold text-xl">
                          {t("allusers")}
                        </div>
                      )} */}
                      <SearchBox
                  // showBarcode={true}
                  searchResult={(values) => searchUser(values)}
                  placeholder={t("Search Users")}
                />

                      <div className="flex justify-between items-center">
                        <div className="font-semibold text-xl mt-2 ">
                          {/* {t("admin")} */}
                        </div>
                        <button
                          onClick={() => {
                            if (
                              checkPermission(
                                "/settings/usermanagement",
                                isGinne
                              )
                            ) {
                              setShowComponent(true);
                            }
                          }}
                          // onClick={() => {
                          //   if (!checkPermission("/settings/usermanagement", isGinne)) {
                          //     return;
                          //   }

                          //   const activeUsers = data.filter((u) => u.active).length;

                          //   const userLimit = data?.[0]?.no_of_user || 0;

                          //   if (activeUsers >= noOfUserLimit) {
                          //     toast.error(t("Cannot add a new user — the user limit for your store has been reached."));
                          //     return;
                          //   }

                          //   setShowComponent(true);
                          // }}
                          className={`font-semibold w-40 mt-5  h-10 border  rounded-lg bg-primaryBlue text-white text-base   flex justify-center items-center gap-2`}
                          type="submit"
                        >
                          <img src={plus} alt="plus" />
                          <p className="">{t("Add User")}</p>
                        </button>
                      </div>
                    </div>
<div className="mt-3 ms-2">
   {data?.length > 0 ? (
                        <div className="font-semibold text-xl">
                          {t("allusers")}
                        </div>
                      ) : 
                      <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {t("No user found.")}
                </div>}
</div>
                    <div className="grid grid-cols-3 gap-x-8 mb-4">
                      {/* {data.map((val, i) => ( */}
                      {data
                        .sort((a, b) =>
                          a.active === b.active ? 0 : a.active ? -1 : 1
                        )
                        .map((val, i) => (
                          <div
                            key={i}
                            className="w-[345px] md:w-full h-30 shadow-sm hover:shadow-lg rounded-xl bg-[#FFFFFF] mt-4 pb-2"
                          >
                            <span className="flex flex-row  justify-between items-center ">
                              <span className="mx-2">
                                {" "}
                                {val?.active === true ? (
                                  <p className=" text-green-500 font-semibold text-3xl">
                                    •
                                  </p>
                                ) : (
                                  <p className=" text-red font-semibold text-3xl">
                                    •
                                  </p>
                                )}
                              </span>
                              {/* {val.active && val?.user_type != "admin" && ( */}
                              {val.active && (
                                <Dropdown
                                  menu={{
                                    items: [
                                      {
                                        key: "1",
                                        icon: <EditOutlined />,
                                        label: t("edit"),
                                        onClick: () => {
                                          setstoreuser(val);
                                          setShowComponent(true);
                                        },
                                      },
                                      {
                                        type: "divider",
                                      },
                                      // Only show this item if NOT admin
                                      ...(val?.user_type !== "admin"
                                        ? [
                                            {
                                              key: "2",
                                              icon: <StopOutlined />,
                                              label:
                                                val?.active === true
                                                  ? t("Deactivate")
                                                  : t("unblock"),
                                              onClick: () => {
                                                if (
                                                  !checkPermission(
                                                    "/settings/usermanagement",
                                                    isGinne
                                                  )
                                                ) {
                                                  return;
                                                }
                                                blockstoreuser(
                                                  val,
                                                  val?.active === true ? 0 : 1
                                                );
                                              },
                                            },
                                            { type: "divider" },
                                          ]
                                        : []),
                                    ],
                                  }}
                                  //     {
                                  //       key: "2",
                                  //       icon: <StopOutlined />,
                                  //       label: val?.active === true ? t("Deactivate") : t("unblock"),
                                  //       // onClick: () =>
                                  //       //   blockstoreuser(val, val?.active === true ? 0 : 1),
                                  //       onClick: () => {
                                  //         if (!checkPermission("/settings/usermanagement", isGinne)) {
                                  //           return;
                                  //         }
                                  //         blockstoreuser(val, val?.active === true ? 0 : 1);
                                  //       },
                                  //     },
                                  //     {
                                  //       type: "divider",
                                  //     },
                                  //   ],
                                  // }}
                                  trigger={["click"]}
                                  placement="bottomRight"
                                  arrow
                                >
                                  <img
                                    src={menu}
                                    alt="menu"
                                    className="float-right cursor-pointer"
                                  />
                                </Dropdown>
                              )}
                            </span>

                            <div className="flex items-center">
                              {val?.image_url?.length >= 30 ? (
                                <img
                                  className="h-16 w-16 object-cover rounded-full ms-4"
                                  src={val.image_url}
                                  alt=""
                                />
                              ) : (
                                <img
                                  className="h-16 w-16 object-cover rounded-full ms-4"
                                  src={noImage}
                                  alt=""
                                />
                              )}
                              <div className="ms-4">
                                <div className="font-medium text-[#272728]">
                                  {val.name}
                                </div>
                                <div className="text-[#999999]">
                                  {t(val.user_type)}
                                </div>
                                {/* <div className="text-black">
                                {t(val.store_name)}
                              </div> */}
                              </div>
                            </div>
                            <div className="ms-5 mt-2  gap-4 text-sm font-normal me-2">
                              <p>
                                {val.last_login &&
                                  `${t("Last Login")} : ${val.last_login}`}
                              </p>
                              {allStores && (
                                <p className="mt-1 font-semibold text-gray-950">
                                  {t("Store Name")} : {val.store_name}
                                </p>
                              )}
                              {!val.active && (
                                <p className="text-red mt-1">
                                  {t("Deactivated")}
                                </p>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {retailerData?.status && retailerData?.status != "approved"
                    ? t(
                        "You cannot add or update user settings until your store is approved by myGINNE."
                      )
                    : ""}
                </div>
              </>
            )}
            {popup && (
              <Blockuserpopup
                onClose={() => setpopup(false)}
                data={blockdata}
                status={status}
              />
            )}
            {/* <p className='ms-20 mt-20'>Yet to be integrated</p> */}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Setting;
